var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a2f8f814-d596-45a2-b81c-de51a3cbb46f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m27.968,40.457c-.535,0-1.053-.214-1.433-.604-.037-.038-3.74-3.837-5.624-5.528-.822-.738-.891-2.002-.153-2.825.738-.821,2.002-.889,2.824-.153,1.043.937,2.554,2.423,3.776,3.646,1.777-3.729,5.247-10.498,8.874-14.748.717-.84,1.979-.939,2.82-.223.84.717.94,1.979.223,2.82-4.713,5.523-9.426,16.304-9.473,16.412-.266.611-.818,1.05-1.474,1.17-.12.022-.241.033-.36.033Z",
    style: {
      fill: "#93e0c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30,11.687c10.098,0,18.313,8.215,18.313,18.313s-8.215,18.313-18.313,18.313-18.313-8.215-18.313-18.313S19.902,11.687,30,11.687m0-4c-12.323,0-22.313,9.99-22.313,22.313s9.99,22.313,22.313,22.313,22.313-9.99,22.313-22.313S42.323,7.687,30,7.687h0Z",
    style: {
      fill: "#93e0c0"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.9ea10d1bc7675e9a4291c9a056dfcaa4.svg";
export { ForwardRef as ReactComponent };